export default [
    {
        path: '/:cid/settings',
        redirect: { name: 'Setting' },
        name: "Settings",
        meta: {
            title: "Settings",
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "settings" */ '@/components/templates/Settings/Settings.vue'),
        children: [
            {
                path: "setting",
                name: "Setting",
                meta: {
                    title: "Settings",
                    requiresAuth: true
                },
                component: () => import(/* webpackChunkName: "settings" */ '@/views/Settings/Setting/Setting.vue')
            },
            {
                path: "custom-field",
                name: "Custom-Fields",
                meta: {
                    title: "Custom Field Manager",
                    requiresAuth: true
                },
                component: () => import(/* webpackChunkName: "settings-custom-fields" */ '@/components/molecules/SettingCustomFieldComponent/SettingCustomFieldComponent.vue')
            },
            {
                path: "members",
                name: "Members",
                meta: {
                    title: "Members",
                    requiresAuth: true
                },
                component: () => import(/* webpackChunkName: "settings-members" */ '@/views/Settings/Members/Members.vue')
            },
            {
                path: "teams",
                name: "Teams",
                meta: {
                    title: "Teams",
                    requiresAuth: true
                },
                component: () => import(/* webpackChunkName: "settings-teams" */ '@/views/Settings/Teams/Teams.vue')
            },
            {
                path: "projects",
                name: "Settings-Projects",
                meta: {
                    title: "Projects",
                    requiresAuth: true
                },
                component: () => import(/* webpackChunkName: "settings-projects" */ '@/views/Settings/Projects/Projects.vue')
            },
            {
                path: "template",
                name: "Template",
                meta: {
                    title: "Templates",
                    requiresAuth: true
                },
                component: () => import(/* webpackChunkName: "settings-template" */ '@/views/Settings/Template/Template.vue')
            },
            // 
            {
                path: "security-permissions",
                name: "Security & Permissions",
                meta: {
                    title: "Security & Permissions",
                    requiresAuth: true
                },
                component: () => import(/* webpackChunkName: "settings-security-permissions" */ '@/views/Settings/SecurityPermissions/SecurityPermissions.vue')
            },
            {
                path: "my-settings",
                name: "My Settings",
                meta: {
                    title: "My Settings",
                    requiresAuth: true
                },
                component: () => import(/* webpackChunkName: "settings-my-settings" */ '@/views/Settings/MySettings/MySettings.vue')
            },
            {
                path: "company",
                name: "Company",
                meta: {
                    title: "Company",
                    requiresAuth: true
                },
                component: () => import(/* webpackChunkName: "settings-company" */ '@/views/Settings/Company/Company.vue')
            },
            {
                path: "notifications",
                name: "Notifications",
                meta: {
                    title: "Notifications",
                    requiresAuth: true
                },
                component: () => import(/* webpackChunkName: "settings-notifications" */ '@/views/Settings/Notifications/Notifications.vue')
            },
            {
                path: "time-tracking",
                name: "Time Tracking",
                meta: {
                    title: "Time Tracking",
                    requiresAuth: true
                },
                component: () => import(/* webpackChunkName: "settings-time-tracking" */ '@/views/Settings/TimeTracking/TimeTracking.vue')
            },
        ]
    },
]
